/* Botanica — PDP "You may also like".
   Fetches Shopify's native recommendation section (Section Rendering API) after
   the page paints, then swaps the real picks in. Fails silent: if there are no
   recommendations yet (fresh catalog, no order history), the row simply stays empty. */
(function () {
  var host = document.querySelector('[data-reco][data-reco-url]');
  if (!host) return;

  fetch(host.getAttribute('data-reco-url'))
    .then(function (res) { return res.text(); })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var inner = doc.querySelector('.pdp-reco__inner');
      if (inner) {
        host.innerHTML = inner.outerHTML;
        host.classList.add('is-loaded');
      }
    })
    .catch(function () { /* leave the row empty on failure */ });
})();
